import type { UserPerfil } from '../types'

const ACCESS_BY_PROFILE: Record<UserPerfil, string[]> = {
  ADMINISTRADOR: ['*'],
  DIRETORIA: ['*'],
  ENGENHARIA: ['/orcamento', '/aprovacoes', '/auditoria', '/obras'],
  SUPRIMENTOS: ['/requisicoes', '/cotacoes', '/ordens-compra', '/recebimentos', '/aprovacoes', '/auditoria'],
  FINANCEIRO: ['/contas-pagar', '/pagamentos', '/contas-receber', '/fluxo-caixa', '/conciliacao', '/aprovacoes', '/auditoria'],
  OPERACIONAL: ['/dashboard', '/aprovacoes', '/auditoria'],
}

const ROUTE_ALIASES: Record<string, string> = {
  '/categorias-orcamentarias': '/categorias',
}

/** Rotas administrativas: visiveis apenas para ADMINISTRADOR e DIRETORIA. */
const ADMIN_ONLY_PATHS = [
  '/cadastros',
  '/clientes',
  '/fornecedores',
  '/colaboradores',
  '/usuarios',
  '/parametros',
  '/regras-workflow',
]

export function normalizePath(path: string) {
  return ROUTE_ALIASES[path] ?? path
}

export function canAccessPath(perfil: UserPerfil | undefined, path: string) {
  if (!perfil) return false

  const normalized = normalizePath(path)

  if (ADMIN_ONLY_PATHS.includes(normalized) && !isPerfilDiretivo(perfil)) return false

  const allowedPaths = ACCESS_BY_PROFILE[perfil] ?? []
  if (allowedPaths.includes('*')) return true
  return allowedPaths.includes(normalized)
}

export function getDefaultPath(perfil: UserPerfil | undefined) {
  if (!perfil) return '/dashboard'
  const allowedPaths = ACCESS_BY_PROFILE[perfil] ?? []
  if (allowedPaths.includes('*')) return '/dashboard'
  return allowedPaths[0] ?? '/dashboard'
}

export function isPerfilDiretivo(perfil: UserPerfil | undefined) {
  return perfil === 'ADMINISTRADOR' || perfil === 'DIRETORIA'
}

export function isAdmin(perfil: UserPerfil | undefined) {
  return isPerfilDiretivo(perfil)
}
